
// import Layout from '@/views/layout/Layout';

const oaPrint = [
  {
    name: 'printMoneyPage',
    path: '/approval/instance/print-money',
    component: () => import('@/views/approval/instance/btnPrintPage/printSpendMoney.vue'),
  },
  {
    name: 'printRecordPage',
    path: '/approval/instance/print-record',
    component: () => import('@/views/approval/instance/btnPrintPage/printFile.vue'),
  },
]

export default oaPrint;